/**
 * Elimina una propiedad de un objeto dado un path tipo "a/b/c"
 * sin modificar el objeto original.
 */
export function removePropertyByPath(obj, path) {
    if (!obj || !path) return obj;

    const clone = structuredClone(obj);
    const keys = path.split("/");

    if (keys.length === 1) {
        delete clone[keys[0]];
        return clone;
    }

    let current = clone;
    for (let i = 0; i < keys.length - 1; i++) {
        if (!(keys[i] in current)) {
            return clone;
        }
        current = current[keys[i]];
    }

    delete current[keys[keys.length - 1]];

    return clone;
}

